import { useLocation } from "react-router-dom";
import { URL_ROOT } from "src/consts/meta";

export function useCanonicalUrl() {
  const location = useLocation();
  return `${URL_ROOT}${location.pathname}`;
}
